import handshakeIcon from "@/assets/images/ideation-phase-images/Handshake.svg";
import acceptableIcon from "@/assets/images/ideation-phase-images/AcceptableIcon.svg";
import warningIcon from "@/assets/icons/SLM/Not Found.svg";
import singleStatusBadgeIcon from "@/assets/icons/Common/SingleStatusBadge.svg";
import statusBadgesIcon from "@/assets/icons/Common/StatusBadges.svg";
import vendorArtworkStatusesIcon from "@/assets/icons/Common/VendorArtworkStatuses.svg";
import casePackIcon from "@/assets/images/ideation-phase-images/CasePackIconRed.svg";
import multipleSitesIcon from "@/assets/images/ideation-phase-images/multipleSitesForContactlist.svg";
import multipleGroupsIcon from "@/assets/images/ideation-phase-images/multipleGroupsForContactlist.svg";
import membersIcon from "@/assets/images/ideation-phase-images/Members.svg";
import taskReceivedDateIcon from "@/assets/images/ideation-phase-images/UiDateIcon.svg";
import taskCountIcon from "@/assets/icons/Common/TaskCount.svg";
import commentsIcon from "@/assets/icons/Common/CommentsTjRed.svg";
import auditLogIcon from "@/assets/icons/Common/UserLogIconTjRed.svg";
import viewIcon from "@/assets/images/ideation-phase-images/ViewIcon.svg";
import editIcon from "@/assets/images/ideation-phase-images/EditIcon.svg";
import deleteIcon from "@/assets/images/ideation-phase-images/DeleteIcon.svg";
import downloadIcon from "@/assets/images/ideation-phase-images/DownloadButton.svg";
import attachmentsIcon from "@/assets/images/ideation-phase-images/AttachmentsIcon.svg";
import validityActiveIcon from "@/assets/icons/Common/ValidityActive.svg";
import validityInactiveIcon from "@/assets/icons/Common/ValidityInactive.svg";
import mandatoryFieldIcon from "@/assets/icons/Common/MandatoryField.svg";
import documentsIcon from "@/assets/images/ideation-phase-images/CertificateAndDocuments.svg";
import helpTooltipIcon from "@/assets/images/ideation-phase-images/HelpIcon.svg";
import flaggedVendorIcon from "@/assets/images/ideation-phase-images/WarnigSignRed.svg";
import infoTooltipIcon from "@/assets/icons/Common/InfoTooltip.svg";
import pendingIcon from "@/assets/icons/Common/Pending.svg";
import productDetailIcon from "@/assets/images/ideation-phase-images/ProductDetail.svg";
import legacyIncompleteIcon from "@/assets/images/ideation-phase-images/LegacyIncompleteIcon.svg";
import { IconGuideItem } from "@/types/IconGuide.types";

const iconGuideData: IconGuideItem[] = [
  {
    id: "handshake",
    icon: handshakeIcon,
  },
  {
    id: "acceptable",
    icon: acceptableIcon,
  },
  {
    id: "warningIcon",
    icon: warningIcon,
  },
  {
    id: "singleStatusBadge",
    icon: singleStatusBadgeIcon,
  },
  {
    id: "statusBadges",
    icon: statusBadgesIcon,
  },
  {
    id: "vendorArtworkStatuses",
    icon: vendorArtworkStatusesIcon,
  },
  {
    id: "multipleSitesIcon",
    icon: multipleSitesIcon,
  },
  {
    id: "multipleGroupsIcon",
    icon: multipleGroupsIcon,
  },
  {
    id: "casePack",
    icon: casePackIcon,
  },
  {
    id: "members",
    icon: membersIcon,
  },
  {
    id: "taskReceivedDate",
    icon: taskReceivedDateIcon,
  },
  {
    id: "taskCount",
    icon: taskCountIcon,
  },
  {
    id: "comments",
    icon: commentsIcon,
  },
  {
    id: "changeLog",
    icon: auditLogIcon,
  },
  {
    id: "view",
    icon: viewIcon,
  },
  {
    id: "edit",
    icon: editIcon,
  },
  {
    id: "delete",
    icon: deleteIcon,
  },
  {
    id: "download",
    icon: downloadIcon,
  },
  {
    id: "attachments",
    icon: attachmentsIcon,
  },
  {
    id: "validityActive",
    icon: validityActiveIcon,
  },
  {
    id: "validityInactive",
    icon: validityInactiveIcon,
  },
  {
    id: "mandatoryField",
    icon: mandatoryFieldIcon,
  },
  {
    id: "documents",
    icon: documentsIcon,
  },
  {
    id: "helpTooltip",
    icon: helpTooltipIcon,
  },
  {
    id: "flaggedVendor",
    icon: flaggedVendorIcon,
  },
  {
    id: "infoTooltip",
    icon: infoTooltipIcon,
  },
  {
    id: "pending",
    icon: pendingIcon,
  },
  {
    id: "productDetail",
    icon: productDetailIcon,
  },
  {
    id: "legacyIncomplete",
    icon: legacyIncompleteIcon,
  },
];

export default iconGuideData;
